import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, Button, Chip,
  TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import CancelIcon from '@mui/icons-material/Cancel';
import { modernTheme } from '../theme';

const getStatusDisplay = (status) => {
  switch (status) {
    case 'pending': return { text: 'Đang chờ', color: 'warning' };
    case 'approved': return { text: 'Đã duyệt', color: 'info' };
    case 'rejected': return { text: 'Từ chối', color: 'error' };
    case 'paid': return { text: 'Đã thanh toán', color: 'success' };
    default: return { text: 'Không xác định', color: 'default' };
  }
};

const AdvanceHistoryDialog = ({ open, onClose, advanceHistory, onCancel }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
    >
      <DialogTitle sx={{ background: modernTheme.gradients.accent, color: 'white', py: 2.5 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box sx={{
            width: 40, height: 40, borderRadius: 2,
            bgcolor: 'rgba(255,255,255,0.2)',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <HistoryIcon />
          </Box>
          <Typography variant="h6" fontWeight={700}>Lịch sử ứng tiền</Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 3, pb: 3 }}>
        {advanceHistory.length > 0 ? (
          <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 2, border: `1px solid ${modernTheme.colors.gray[200]}` }}>
            <Table>
              <TableHead sx={{ bgcolor: modernTheme.colors.gray[50] }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Số tiền</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Ngày yêu cầu</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Kỳ thanh toán</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Trạng thái</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Ghi chú</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Thao tác</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {advanceHistory.map((item) => {
                  const status = getStatusDisplay(item.status);
                  return (
                    <TableRow key={item._id} hover>
                      <TableCell sx={{ fontWeight: 600 }}>
                        {new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(item.amount)}
                      </TableCell>
                      <TableCell>{new Date(item.requestDate).toLocaleDateString('vi-VN')}</TableCell>
                      <TableCell>
                        {item.periodId
                          ? `${new Date(item.periodId.periodStart).toLocaleDateString('vi-VN')} - ${new Date(item.periodId.periodEnd).toLocaleDateString('vi-VN')}`
                          : 'N/A'}
                      </TableCell>
                      <TableCell><Chip label={status.text} color={status.color} size="small" /></TableCell>
                      <TableCell>{item.notes || 'Không có'}</TableCell>
                      <TableCell>
                        {item.status === 'pending' && (
                          <Button variant="outlined" color="error" size="small" startIcon={<CancelIcon />}
                            onClick={() => onCancel(item._id)}
                            sx={{ borderRadius: 2, textTransform: 'none' }}
                          >
                            Hủy
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Box sx={{ textAlign: 'center', py: 6 }}>
            <HistoryIcon sx={{ fontSize: 48, color: modernTheme.colors.gray[300], mb: 2 }} />
            <Typography variant="body1" color="text.secondary">
              Bạn chưa có yêu cầu ứng tiền nào.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} variant="contained"
          sx={{ background: modernTheme.gradients.primary, borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdvanceHistoryDialog;
